import { SPORT_TYPE } from '../constant';

/**
 * 获取标志内容
 * @param {String} theme 主题
 * @param {String} text 标志内容文字
 * @param {Boolean} isGoogleMap 是否为谷歌地图
 * @returns {String|Object}
 */
export function getMarkerContent(theme, text, isGoogleMap) {
  const className = `lap-marker${theme === 'theme-dark' ? ' dark' : ''}`;

  if (isGoogleMap) {
    return { text: `${text}`, className };
  }

  return `<div class="${className}">${text}</div>`;
}

// 获取地图上单位像素代表多少米
export const getScalePerPixel = (zoom) => 0.2531 * 2 ** (19 - zoom);

/**
 * 返回目标圈数据类型
 * @param {Number} sportType 运动类型
 * @returns Number
 */
export function getTargetLapType(sportType) {
  if (checkIfIsSkiing(sportType)) {
    return 1;
  }

  if (sportType === SPORT_TYPE.MOUNTAIN_SKIING) {
    return 4;
  }

  return 2;
}

/**
 * 判断是否滑雪运动：单板/双板滑雪
 * @param {Number} sportType 运动类型
 * @returns Boolean
 */
export const checkIfIsSkiing = (sportType) => [SPORT_TYPE.SNOW_BOARD, SPORT_TYPE.SKI_BOARD].includes(sportType);

/**
 * 格式化原始经纬度数据
 * @param {Number} lon 经度
 * @param {Number} lat 纬度
 * @returns Array
 */
export function normalizeGps(lon, lat) {
  return [lon / 10000000, lat / 10000000];
}

/**
 * 二分法查找大于等于目标时间戳的点的序号
 * @param {Array} array 数据
 * @param {Number} target 时间戳
 * @returns Number
 */
export function binarySearch(array, target) {
  let low = 0;
  let high = array.length - 1;
  while (low <= high) {
    const mid = Math.floor((low + high) / 2);
    if (array[mid].timestamp < target) {
      low = mid + 1;
    } else {
      high = mid - 1;
    }
  }
  return low;
}
